export default "__VITE_ASSET__DuR$j5cO__"